<template>
  <b-container v-if="loaded">
    <b-row>
      <b-col v-if="admin || elevator.user_role_id > 1" align="right">

        <b-form-checkbox v-if="(admin || elevator.user_role_id > 3) && elevator.relays && elevator.relay1label != ''"
          v-model="elevator.relay1" name="relay1-checkbox" @change="updateRelays('1')" switch>{{ elevator.relay1label
          }}</b-form-checkbox>

        <b-form-checkbox v-if="(admin || elevator.user_role_id > 3) && elevator.relays && elevator.relay2label != ''"
          v-model="elevator.relay2" name="relay2-checkbox" @change="updateRelays('2')" switch>{{ elevator.relay2label
          }}</b-form-checkbox>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 3) && (
          elevator.type == 'otis' ||
          elevator.type == 'otisesc' ||
          elevator.type == 'schindler3300' ||
          elevator.type == 'konemap' ||
          elevator.type == 'mpk' ||
          elevator.type == 'lisa'
        )" :variant="mode === 'interact' ? 'dark' : 'primary'"
          :disabled="elevator.connected != 1 || elevator.online != 1" @click.stop="toggleMode()">
          {{ mode === 'interact' ? 'Monitor' : 'Interact' }}
        </b-button>

        <b-button size="sm" v-if="admin && (
          elevator.type == 'arkel' ||
          elevator.type == 'schindler3300'
        )" variant="danger" :disabled="!canControl" @click.stop="modalResetOpen($event.target)">
          Reset
        </b-button>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 1) && (
          elevator.type == 'schindler' ||
          elevator.type == 'schindlercan' ||
          elevator.type == 'schindler3100' ||
          elevator.type == 'schindler3300'
        )" variant="danger" :disabled="!canControl" @click.stop="modalClearErrorsOpen($event.target, elevator.id)"
          class="mr-1">
          Clear Events
        </b-button>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 1) &&
          (
            elevator.type == 'schindler' ||
            elevator.type == 'schindlercan' ||
            elevator.type == 'schindlerBX' ||
            elevator.type == 'schindler3100' ||
            elevator.type == 'schindler3300'
          )" variant="secondary" @click.stop="modalStatusReportOpen($event.target)" :disabled="!canControl">
          Status
        </b-button>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 1) &&
          (
            elevator.type == 'arca' ||
            elevator.type == 'kollmorgen' ||
            elevator.type == 'kone' ||
            elevator.type == 'lester' ||
            elevator.type == 'mec32' ||
            elevator.type == 'mpk' ||
            elevator.type == 'mpktcp' ||
            elevator.type == 'otis' ||
            elevator.type == 'otisesc' ||
            elevator.type == 'schindler' ||
            elevator.type == 'schindlercan' ||
            elevator.type == 'schindler3100' ||
            elevator.type == 'schindler3300' ||
            elevator.type == 'schindlerBX' ||
            elevator.type == 'tci'
          )" variant="secondary" @click.stop="modalErrorsOpen($event.target)" :disabled="!canControl">
          Events
        </b-button>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 1) &&
          (
            elevator.type == 'otis' ||
            elevator.type == 'konemap'
          )" variant="secondary" @click.stop="modalInputsOpen($event.target)" :disabled="!canControl">
          Inputs
        </b-button>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 1) &&
          (
            elevator.type == 'schindlerBX' ||
            elevator.type == 'schindler' ||
            elevator.type == 'schindlercan' ||
            elevator.type == 'schindler3100' ||
            elevator.type == 'schindler3300'
          )" variant="secondary" @click.stop="inputsGroup = 'SCIC'; modalInputsOpen($event.target)"
          :disabled="!canControl">
          SCIC
        </b-button>
        <b-button size="sm" v-if="(admin || elevator.user_role_id > 1) &&
          (
            elevator.type == 'schindler' ||
            elevator.type == 'schindlercan' ||
            elevator.type == 'schindlerBX' ||
            elevator.type == 'schindler3100' ||
            elevator.type == 'schindler3300'
          )" variant="secondary" @click.stop="inputsGroup = 'SDIC'; modalInputsOpen($event.target)"
          :disabled="!canControl">
          SDIC
        </b-button>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 3) && elevator.type == 'mpktcp'" variant="info"
          :href="proxyUrl" target="_blank">
          MPK Live
        </b-button>

        <b-button size="sm" v-if="admin && elevator.status != -1" variant="danger" @click.stop="repairOn()">
          Disable
        </b-button>

        <b-button size="sm" v-if="admin && elevator.status == -1" variant="danger" @click.stop="repairOff()">
          Enable
        </b-button>

        <b-button size="sm" v-if="(admin || elevator.user_role_id > 2)" variant="primary"
          @click.stop="modalFormOpen($event.target)">
          Edit
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <h1>
          <svg class="svg-icon" height="40" width="40" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
            <title>{{ nameForStatus(elevator.status) }}</title>
            <circle :class="classForElevator(elevator)" cx="5" cy="5" r="5" />
          </svg>
          {{ elevatorName(elevator) }}
        </h1>
      </b-col>
    </b-row>

    <b-row v-if="elevator.status === 5" class="mt-2">
      <b-col>
        <b-alert show variant="danger" class="mb-4 d-flex justify-content-between align-items-start">
          <span>
            <strong>Breakdown detected</strong>
            <br v-if="outageDuration" />
            <small v-if="outageDuration"> {{ outageDuration }} ago</small>
          </span>
          <span v-if="elevator.fault">{{ elevator.fault }}</span>
        </b-alert>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-row class="mb-2">
          <b-col sm="4" class="text-sm-right"><b>Brand:</b></b-col>
          <b-col>{{ elevatorBrandFormatter(elevator.type) }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevatorTypeFormatter(elevator.type) != ''">
          <b-col sm="4" class="text-sm-right"><b>Type:</b></b-col>
          <b-col>{{ elevatorTypeFormatter(elevator.type) }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.host">
          <b-col sm="4" class="text-sm-right"><b>SN:</b></b-col>
          <b-col>{{ elevator.host }}</b-col>
        </b-row>

        <b-row class="mb-2"
          v-if="elevator.addressLine1 || elevator.city || elevator.zipCode || elevator.region || elevator.country">
          <b-col sm="4" class="text-sm-right"><b>Address:</b></b-col>
          <b-col>
            <span v-if="elevator.addressLine1">{{ elevator.addressLine1 }}<br /></span>
            <span v-if="elevator.addressLine2">{{ elevator.addressLine2 }}<br /></span>
            <span v-if="elevator.zipCode">{{ elevator.zipCode }}</span>
            <span v-if="elevator.city">{{ elevator.city }}<br /></span>
            <span v-if="elevator.region">{{ elevator.region }}<span v-if="elevator.country">,</span></span>
            <span v-if="elevator.country">{{ elevator.country }}</span>
          </b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.cid">
          <b-col sm="4" class="text-sm-right"><b>Installation number:</b></b-col>
          <b-col>{{ elevator.cid }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.cdate">
          <b-col sm="4" class="text-sm-right"><b>Commission date:</b></b-col>
          <b-col>{{ elevator.cdate }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.description">
          <b-col sm="4" class="text-sm-right"><b>Description:</b></b-col>
          <b-col>{{ elevator.description }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.eqdescr">
          <b-col sm="4" class="text-sm-right"><b>Equipment Description:</b></b-col>
          <b-col>{{ elevator.eqdescr }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.notes">
          <b-col sm="4" class="text-sm-right"><b>Notes:</b></b-col>
          <b-col style="white-space: pre-wrap">{{ elevator.notes }}</b-col>
        </b-row>

      </b-col>

      <b-col>
        <b-row class="mb-2">
          <b-col class="text-sm-right"><b>State:</b></b-col>
          <b-col>{{ nameForStatus(elevator.status) }}</b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="text-sm-right"><b>Position:</b></b-col>
          <b-col v-if="elevator.position_label != ''">{{ elevator.position_label }}</b-col>
          <b-col v-else>{{ elevator.position }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.doorFront > 0 && elevator.doorBack == 0">
          <b-col class="text-sm-right"><b>Door:</b></b-col>
          <b-col v-if="elevator.doorFront == 1">Closed</b-col>
          <b-col v-else-if="elevator.doorFront == 2">Open</b-col>
          <b-col v-else></b-col>
        </b-row>

        <b-row class="mb-2" v-else-if="elevator.doorFront > 0 && elevator.doorBack > 0">
          <b-col class="text-sm-right"><b>Front door:</b></b-col>
          <b-col v-if="elevator.doorFront == 1">Closed</b-col>
          <b-col v-else-if="elevator.doorFront == 2">Open</b-col>
          <b-col v-else></b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.doorFront > 0 && elevator.doorBack > 0">
          <b-col class="text-sm-right"><b>Rear door:</b></b-col>
          <b-col v-if="elevator.doorBack == 1">Closed</b-col>
          <b-col v-else-if="elevator.doorBack == 2">Open</b-col>
          <b-col v-else></b-col>
        </b-row>

        <!-- <b-row class="mb-2" v-if="elevator.temperature != -255"> -->
        <!--   <b-col class="text-sm-right"><b>Temperature:</b></b-col> -->
        <!--   <b-col>{{ elevator.temperature }}&deg; C</b-col> -->
        <!-- </b-row> -->
        <!---->
        <!-- <b-row class="mb-2" v-if="elevator.illumination != -1"> -->
        <!--   <b-col class="text-sm-right"><b>Illuminance:</b></b-col> -->
        <!--   <b-col>{{ elevator.illumination }} lux</b-col> -->
        <!-- </b-row> -->

        <b-row class="mb-2" v-if="elevator.avgTripsPerDay">
          <b-col class="text-sm-right"><b>Trips per day:</b></b-col>
          <b-col>{{ Math.round(elevator.avgTripsPerDay) }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="!elevator.plannedDate && (elevator.estimatedDate || elevator.stopsUntilService <= 0)">
          <b-col class="text-sm-right"><b>Est. maintenance:</b></b-col>
          <b-col>
            <span v-if="elevator.stopsUntilService <= 0">Due now</span>
            <span v-else-if="elevator.estimatedDate" :class="maintenanceDueDateClass">
              {{ dateFormatter(elevator.estimatedDate) }}
            </span>
            <span v-else class="text-muted">Insufficient data</span>
          </b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.plannedDate">
          <b-col class="text-sm-right"><b>Scheduled maintenance:</b></b-col>
          <b-col>{{ dateFormatter(elevator.plannedDate) }}</b-col>
        </b-row>

        <b-row class="mb-2" v-if="elevator.waterlevel != -2">
          <b-col class="text-sm-right"><b>Water:</b></b-col>
          <b-col>{{ waterlevelFormatter(elevator.waterlevel) }}</b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-3" sm="12" v-if="this.elevator.camURL && this.elevator.camURL != ''">
      <b-col v-if="this.camURL == ''">
        Loading camera image...
      </b-col>
      <b-col v-else>
        <img :src="this.camURL" @click="reloadCamera()">
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="(admin || elevator.user_role_id > 3) && (
      elevator.type == 'otis' ||
      elevator.type == 'arkel' ||
      elevator.type == 'konemap' ||
      elevator.type == 'schindler' ||
      elevator.type == 'schindlercan' ||
      elevator.type == 'schindler3100' ||
      elevator.type == 'schindler3300' ||
      elevator.type == 'schindlerBX'
    ) && stats && stats.length > 0">
      <b-col sm="5">
        <h2>Call</h2>
        <span class="m-1" v-for="(stat, index) in stats" :key="stat.position">
          <b-button variant="danger" @click.stop="call(index)" :disabled="!canControl">
            {{ stat.position }}
          </b-button>
        </span>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="(admin || elevator.user_role_id > 3) && (
      elevator.type == 'mpk' ||
      elevator.type == 'mpktcp'
    ) && stats && stats.length > 0">
      <b-col sm="5">
        <h2>Call</h2>
        <span class="m-1" v-for="(stat, index) in stats" :key="stat.position">
          <b-button variant="danger" @click.stop="call(index + 1)" :disabled="!canControl">
            {{ stat.position }}
          </b-button>
        </span>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="(admin || elevator.user_role_id > 3) && hasIO">
      <b-col>
        <h2>I/O</h2>
        <b-row class="mb-3">
          <b-col>&nbsp;</b-col>
          <b-col><strong>Input</strong></b-col>
          <b-col><strong>Output</strong></b-col>
          <b-col>&nbsp;</b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col><strong>1.</strong></b-col>

          <b-col v-if="ioi1 == '1'" class="high">{{ ioi1 }}</b-col>
          <b-col v-else class="low">{{ ioi1 }}</b-col>

          <b-col v-if="ioo1 == '1'" class="high">{{ ioo1 }}</b-col>
          <b-col v-else class="low">{{ ioo1 }}</b-col>

          <b-col>
            <b-button v-if="ioo1 == '0'" size="sm" @click.stop="liftWS.send('!O11')">On</b-button>
            <b-button v-if="ioo1 == '1'" size="sm" @click.stop="liftWS.send('!O10')">Off</b-button>
            <b-button v-if="ioo1 == '?'" size="sm" disabled>Off</b-button>
            <b-button v-if="ioo1 == '?'" size="sm" disabled>Pulse</b-button>
            <b-button v-else size="sm" @click.stop="liftWS.send('!P1')">Pulse</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col><strong>2.</strong></b-col>

          <b-col v-if="ioi2 == '1'" class="high">{{ ioi2 }}</b-col>
          <b-col v-else class="low">{{ ioi2 }}</b-col>

          <b-col v-if="ioo2 == '1'" class="high">{{ ioo2 }}</b-col>
          <b-col v-else class="low">{{ ioo2 }}</b-col>

          <b-col>
            <b-button v-if="ioo2 == '0'" size="sm" @click.stop="liftWS.send('!O21')">On</b-button>
            <b-button v-if="ioo2 == '1'" size="sm" @click.stop="liftWS.send('!O20')">Off</b-button>
            <b-button v-if="ioo2 == '?'" size="sm" disabled>Off</b-button>
            <b-button v-if="ioo2 == '?'" size="sm" disabled>Pulse</b-button>
            <b-button v-else size="sm" @click.stop="liftWS.send('!P2')">Pulse</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col><strong>3.</strong></b-col>

          <b-col v-if="ioi3 == '1'" class="high">{{ ioi3 }}</b-col>
          <b-col v-else class="low">{{ ioi3 }}</b-col>

          <b-col v-if="ioo3 == '1'" class="high">{{ ioo3 }}</b-col>
          <b-col v-else class="low">{{ ioo3 }}</b-col>

          <b-col>
            <b-button v-if="ioo3 == '0'" size="sm" @click.stop="liftWS.send('!O31')">On</b-button>
            <b-button v-if="ioo3 == '1'" size="sm" @click.stop="liftWS.send('!O30')">Off</b-button>
            <b-button v-if="ioo3 == '?'" size="sm" disabled>Off</b-button>
            <b-button v-if="ioo3 == '?'" size="sm" disabled>Pulse</b-button>
            <b-button v-else size="sm" @click.stop="liftWS.send('!P3')">Pulse</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col><strong>4.</strong></b-col>

          <b-col v-if="ioi4 == '1'" class="high">{{ ioi4 }}</b-col>
          <b-col v-else class="low">{{ ioi4 }}</b-col>

          <b-col v-if="ioo4 == '1'" class="high">{{ ioo4 }}</b-col>
          <b-col v-else class="low">{{ ioo4 }}</b-col>

          <b-col>
            <b-button v-if="ioo4 == '0'" size="sm" @click.stop="liftWS.send('!O41')">On</b-button>
            <b-button v-if="ioo4 == '1'" size="sm" @click.stop="liftWS.send('!O40')">Off</b-button>
            <b-button v-if="ioo4 == '?'" size="sm" disabled>Off</b-button>
            <b-button v-if="ioo4 == '?'" size="sm" disabled>Pulse</b-button>
            <b-button v-else size="sm" @click.stop="liftWS.send('!P4')">Pulse</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="(admin || elevator.user_role_id > 3) && elevator.connected == 1 && (
      elevator.type == 'otis' ||
      elevator.type == 'otisesc' ||
      elevator.type == 'schindler3300' ||
      elevator.type == 'konemap' ||
      elevator.type == 'mpk' ||
      elevator.type == 'lisa'
    ) && mode === 'interact'">
      <b-col :cols="elevator.type === 'lisa' ? 12 : 6">
        <h2>Interact</h2>

        <pre class="terminal-mpk" v-if="elevator.type == 'mpk'">{{ screen }}</pre>
        <div class="log-viewer" ref="lisaLog" v-else-if="elevator.type == 'lisa'">
          <div v-for="(entry, i) in logLines" :key="i" class="log-line">
            <span class="log-time">{{ entry.time }}</span>
            <span :class="['log-level', 'log-level--' + (entry.level || 'INFO').toLowerCase()]">{{ entry.level || 'INFO' }}</span>
            <span class="log-message">{{ entry.message }}</span>
          </div>
        </div>
        <pre class="terminal" v-else>{{ screen }}</pre>

        <b-row class="mt-2 mb-2" v-if="elevator.type == 'lisa'">
          <b-col align="right">
            <b-button size="sm" variant="danger" @click.stop="clearLog()">Clear log</b-button>
          </b-col>
        </b-row>

        <b-row class="mb-2" v-if="(admin || elevator.user_role_id > 3) && elevator.type == 'mpk'">
          <b-col sm="2" v-if="elevator.type == 'mpk'">
            <b-button size="sm" variant="danger" @click.stop="modalMPKResetOpen($event.target)">Reset</b-button>
          </b-col>

          <b-col>
            <b-row class="mb-1">

              <b-col>
                <b-button class="w-100" size="sm" @click.stop="ws.send('+')">+</b-button>
              </b-col>

              <b-col>
                <b-button class="w-100" size="sm" @click.stop="ws.send('u')">↑</b-button>
              </b-col>

              <b-col>
                <b-button class="w-100" size="sm" @click.stop="ws.send('e')">ESC</b-button>
              </b-col>
            </b-row>

            <b-row class="mb-1">
              <b-col>
                <b-button class="w-100" size="sm" @click.stop="ws.send('-')">-</b-button>
              </b-col>

              <b-col>
                <b-button class="w-100" size="sm" @click.stop="ws.send('d')">↓</b-button>
              </b-col>

              <b-col>
                <b-button class="w-100" size="sm" @click.stop="ws.send('o')">OK</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-2" v-if="(admin || elevator.user_role_id > 3) && elevator.type == 'schindler3300'">
          <b-col>
            <b-row class="mb-1">
              <b-col>
                <b-button size="sm" @click.stop="ws.send('e')">Escape</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('d')">Down</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('u')">Up</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('r')">Return</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-2" v-if="(admin || elevator.user_role_id > 3) && elevator.type == 'konemap'">
          <b-col>
            <b-row class="mb-1">
              <b-col>
                <b-button size="sm" @click.stop="ws.send('m')">menu</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('u')">up</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('d')">down</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('s')">select</b-button>
              </b-col>
            </b-row>

            <b-row class="mb-1">
              <b-col>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('U')">up call</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('D')">down call</b-button>
              </b-col>
              <b-col>
                <b-button size="sm" @click.stop="ws.send('C')">car call</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-2"
          v-if="(admin || elevator.user_role_id > 3) && (elevator.type == 'otis' || elevator.type == 'otisesc')">
          <b-col>
            <b-row class="mb-1">
              <b-col>
                <b-button size="sm" @click.stop="ws.send('M')">module</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('7')">7</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('X')">disp state / d</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('8')">8</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('Y')">ent call / e</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('9')">9</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('H')">test / f</b-button>
              </b-col>
            </b-row>

            <b-row class="mb-1">
              <b-col>
                <b-button size="sm" @click.stop="ws.send('F')">function</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('4')">4</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('e')">disp in / a</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('5')">5</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('f')">sel out / b</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('6')">6</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('R')">c</b-button>
              </b-col>
            </b-row>

            <b-row class="mb-1">
              <b-col>
                <b-button size="sm" @click.stop="ws.send('S')">set</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('1')">1</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('b')">on</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('2')">2</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('c')">up</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('3')">3</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('d')">down</b-button>
              </b-col>
            </b-row>

            <b-row class="mb-1">
              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="shift = true">shift</b-button>
                <b-button size="sm" v-else @click.stop="shift = false">unshift</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('0')">0</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('a')">off</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('>')">go on</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('<')">go back</b-button>
              </b-col>

              <b-col>
                <b-button size="sm" v-if="!shift" @click.stop="ws.send('\x7F')">clear</b-button>
                <b-button size="sm" v-else @click.stop="ws.send('\x0D')">enter</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <h2>History</h2>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col sm="12" md="12" lg="8">
        <b-row>
          <b-col md="3">
            From: <date-picker :value="fromInput" @change="setFromInput" />
          </b-col>
          <b-col md="3">
            To: <date-picker :value="toInput" @change="setToInput" />
          </b-col>
          <b-col align-v="center" v-if="!statsLoaded">
            Loading...
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-button size="sm" class="mt-1" @click="setRange('today')">Today</b-button>
            <b-button size="sm" class="mt-1" @click="setRange('yesterday')">Yesterday</b-button>
            <b-button size="sm" class="mt-1" @click="setRange('thisWeek')">This Week</b-button>
            <b-button size="sm" class="mt-1" @click="setRange('lastWeek')">Last Week</b-button>
            <b-button size="sm" class="mt-1" @click="setRange('thisMonth')">This Month</b-button>
            <b-button size="sm" class="mt-1" @click="setRange('lastMonth')">Last Month</b-button>
            <b-button size="sm" class="mt-1" @click="setRange('thisYear')">This Year</b-button>
            <b-button size="sm" class="mt-1" @click="setRange('lastYear')">Last Year</b-button>
          </b-col>
        </b-row>
      </b-col>

      <b-col sm="12" md="12" lg="4" class="d-none d-lg-flex align-items-end justify-content-end">
        <b-button v-if="admin && stats && stats.length > 0" size="sm" variant="secondary"
          @click.stop="modalPositionLabelsOpen($event.target)">Edit Labels</b-button>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col sm="12" md="12" lg="8">
        <b-row class="chart-row">
          <b-col>
            <barchart :data="statsChartData" v-if="stats && stats.length > 0" />
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" md="12" lg="4">
        <div class="d-lg-none mb-2 text-right" v-if="admin && stats && stats.length > 0">
          <b-button size="sm" variant="secondary" @click.stop="modalPositionLabelsOpen($event.target)">Edit
            Labels</b-button>
        </div>
        <b-table small striped :items="stats" :fields="statsFields" foot-clone>
          <template #foot(position)="data">
            {{ data.position }}
          </template>
          <template #foot(stop)="data">
            {{ countStops }}
          </template>
          <template #foot(open)="data">
            {{ countOpen }}
          </template>
          <template #foot(openBack)="data">
            {{ countOpenBack }}
          </template>
          <template #foot(close)="data">
            {{ countClose }}
          </template>
          <template #foot(closeBack)="data">
            {{ countCloseBack }}
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="events && events.length > 0">
      <b-col>
        <b-row>
          <b-col>
            <h3>Events</h3>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table striped :items="events" :fields="eventsFields" :per-page="eventsPerPage"
              :current-page="eventsCurrentPage" :sort-by.sync="eventsSortBy" :sort-desc.sync="eventsSortDesc"
              @sort-changed="onEventsSortChanged" :busy="!eventsLoaded">
              <template #table-busy>
                <div class="text-center my-3"><b-spinner small /> Loading&hellip;</div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row v-if="events.length > 15" class="mt-2 align-items-center">
          <b-col cols="auto">
            <b-form-select v-model="eventsPerPage" :options="[15, 30, 50, 100]" style="width: auto"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination v-if="events.length > eventsPerPage" v-model="eventsCurrentPage" :total-rows="events.length"
              :per-page="eventsPerPage" class="mb-0"></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="outages && outages.length > 0">
      <b-col>
        <b-row>
          <b-col>
            <h3>Breakdowns</h3>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table striped :items="outages" :fields="outagesFields" :per-page="outagesPerPage"
              :current-page="outagesCurrentPage" :sort-by.sync="outagesSortBy" :sort-desc.sync="outagesSortDesc"
              @sort-changed="onOutagesSortChanged" :busy="!outagesLoaded">
              <template #table-busy>
                <div class="text-center my-3"><b-spinner small /> Loading&hellip;</div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row v-if="outages.length > 15" class="mt-2 align-items-center">
          <b-col cols="auto">
            <b-form-select v-model="outagesPerPage" :options="[15, 30, 50, 100]" style="width: auto"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination v-if="outages.length > outagesPerPage" v-model="outagesCurrentPage"
              :total-rows="outages.length" :per-page="outagesPerPage" class="mb-0"></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-row>
          <b-col>
            <h2>Support</h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-row class="mb-2">
                <b-col>
                  <b>Subject:</b>
                  <b-form-input id="subject" type="text" autocomplete="off" v-model="subject"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b>Message:</b>
                  <b-form-textarea id="message" autocomplete="off" v-model="body"></b-form-textarea>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-button @click="sendMail()">Send</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal id="modalStatusReport" size="xl" @hide="modalStatusReportReset" :title="modalStatusReport.title"
      ok-variant="primary" cancel-variant="hidden" :busy="!statusLoaded">
      <template slot="modal-footer">
        <b-button variant="primary" @click.stop="modalStatusReportClose()">
          Close
        </b-button>
      </template>
      <b-container v-if="statusLoaded">
        <div v-if="statusReport != ''" class="status-report">
          <pre>{{ statusReport }}</pre>
        </div>
        <div v-else>
          {{ status }}
        </div>
      </b-container>
      <b-container v-else>
        Loading...
      </b-container>
    </b-modal>

    <b-modal id="modalErrors" size="xl" @hide="modalErrorsReset" :title="modalErrors.title" ok-variant="primary"
      cancel-variant="hidden" :busy="!errorsLoaded">
      <template slot="modal-footer">
        <b-button variant="primary" @click.stop="modalErrorsClose()">
          Close
        </b-button>
      </template>
      <b-container v-if="errorsLoaded">

        <b-container v-if="(elevator.type == 'tci')">
          <b-table v-if="errors && errors.length > 0" striped :items="errors" :fields="errorsFieldsNoTime" bordered
            small></b-table>
          <b-container v-else>
            {{ status }}
          </b-container>
        </b-container>
        <b-container v-else>
          <b-table v-if="errors && errors.length > 0" striped :items="errors" :fields="errorsFields" bordered
            small></b-table>
          <b-container v-else>
            {{ status }}
          </b-container>
        </b-container>

      </b-container>
      <b-container v-else>
        Loading...
      </b-container>
    </b-modal>

    <b-modal id="modalInputs" title="Inputs" ok-variant="primary" :busy="!inputsLoaded">
      <template slot="modal-footer">
        <b-button variant="primary" @click.stop="modalInputsClose()">
          Close
        </b-button>
      </template>
      <b-container v-if="inputsLoaded">
        <b-table v-if="inputs.length > 0" striped :items="inputs" bordered small></b-table>
        <b-container v-else>
          {{ status }}
        </b-container>
      </b-container>
      <b-container v-else>
        Loading...
      </b-container>
    </b-modal>

    <b-modal id="modalForm" @hide="modalFormReset" :title="modalForm.title" ok-variant="primary" @ok="updateElevator()">
      <b-form v-if="showForm">
        <b-form-input id="id" type="text" v-model="form.id" hidden></b-form-input>

        <b-form-group id="nameInputGroup" label="Name" label-for="name">
          <b-form-input id="name" type="text" v-model="form.name" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="descriptionInputGroup" label="Description" label-for="description">
          <b-form-textarea id="description" v-model="form.description"></b-form-textarea>
        </b-form-group>

        <b-form-group id="addressLine1InputGroup" label="Address" label-for="addressLine1">
          <b-form-input id="addressLine1" type="text" v-model="form.addressLine1" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
          <b-form-input id="addressLine2" type="text" v-model="form.addressLine2" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="zipcodeInputGroup" label="Postcode" label-for="zipCode">
          <b-form-input id="zipCode" type="text" v-model="form.zipCode" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="cityInputGroup" label="City" label-for="city">
          <b-form-input id="city" type="text" v-model="form.city" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="regionInputGroup" label="Region" label-for="region">
          <b-form-input id="region" type="text" v-model="form.region" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="countryInputGroup" label="Country" label-for="country">
          <b-form-input id="country" type="text" v-model="form.country" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="cidInputGroup" label="Installation number" label-for="cid">
          <b-form-input id="cid" type="text" v-model="form.cid" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="cdateInputGroup" label="Commission date" label-for="cid">
          <b-form-input id="cdate" type="text" v-model="form.cdate" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="eqdescrInputGroup" label="Equipment description" label-for="eqdescr">
          <b-form-input id="eqdescr" type="text" v-model="form.eqdescr" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="notesInputGroup" label="Notes" label-for="notes">
          <b-form-textarea id="notes" v-model="form.notes" rows="4"></b-form-textarea>
        </b-form-group>

        <b-form-group id="stopsUntilServiceInputGroup" label="Trips until maintenance" label-for="stopsUntilService">
          <b-form-input id="stopsUntilService" type="text" v-model="form.stopsUntilService" autocomplete="off"
            @keydown.native.enter="onEnter"></b-form-input>
        </b-form-group>

        <b-form-group id="outageThresholdInputGroup" label="Outage threshold" label-for="outageThreshold">
          <b-input-group append="seconds">
            <b-form-input id="outageThreshold" type="number" min="0" v-model="form.outageThreshold" autocomplete="off"
              @keydown.native.enter="onEnter"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal id="modalClearErrors" title="Clear Events" ok-variant="danger" @ok="clearErrors(modalClearErrors)">
      <p>Are you sure you want to clear the events?</p>
    </b-modal>

    <b-modal id="modalMPKReset" title="Reset" ok-variant="danger" @ok="mpkReset()">
      <p>Are you sure you want to reset?</p>
    </b-modal>

    <b-modal id="modalReset" title="Reset" ok-variant="danger" @ok="controllerReset()">
      <p>Are you sure you want to reset the controller?</p>
    </b-modal>

    <b-modal id="modalPositionLabels" title="Edit Position Labels" @ok="savePositionLabels()">
      <b-form>
        <b-form-group v-for="item in positionLabels" :key="item.position_int" :label="'Position ' + item.position_int">
          <b-form-input v-model="item.label" type="text" autocomplete="off"></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment';
import BarChart from './BarChart.vue';
import formatter from './formatter.mixin.js';
import { BASE_URL } from './endpoint.js';
import { openWS } from './ws.js';
import DatePicker from './DatePicker.vue'

export default {
  name: 'elevator',
  components: {
    'barchart': BarChart,
    DatePicker,
  },
  props: [
    'settings',
    'reset',
    'del',
  ],
  mixins: [formatter],
  data() {
    return {
      subject: "",
      body: "",

      hasIO: false,
      ioi1: "?",
      ioi2: "?",
      ioi3: "?",
      ioi4: "?",
      ioo1: "?",
      ioo2: "?",
      ioo3: "?",
      ioo4: "?",

      shift: false,
      mode: 'monitor',
      screen: '',
      logWs: null,
      logLines: [],
      loaded: false,
      camURL: '',
      elevator: null,
      stats: [],
      statsLoaded: false,
      positionLabels: [],
      now: moment(),
      liftWS: null,
      from: null,
      fromInput: null,
      to: null,
      toInput: null,
      modalForm: { title: '' },
      modalStatusReport: { title: '' },
      modalErrors: { title: '' },
      modalInputs: { title: '' },
      modalClearErrors: { id: null },
      status: "",
      statusLoaded: false,
      statusReport: "",
      errors: [],
      errorsLoaded: false,
      inputs: [],
      inputsLoaded: false,
      inputsGroup: '',
      events: [],
      eventsLoaded: false,
      eventsCurrentPage: 1,
      eventsPerPage: parseInt(localStorage.getItem('elevatorEventsPerPage')) || 15,
      eventsSortBy: localStorage.getItem('elevatorEventsSortBy') || 'time',
      eventsSortDesc: localStorage.getItem('elevatorEventsSortDesc') !== 'false',
      outages: [],
      outagesLoaded: false,
      outagesCurrentPage: 1,
      outagesPerPage: parseInt(localStorage.getItem('elevatorOutagesPerPage')) || 15,
      outagesSortBy: localStorage.getItem('elevatorOutagesSortBy') || 'started_at',
      outagesSortDesc: localStorage.getItem('elevatorOutagesSortDesc') !== 'false',
      currentOutages: [],
      showForm: true,
      maintenancePlan: null,
      form: {
        id: '',
        name: '',
        description: '',
        addressLine1: '',
        addressLine2: '',
        zipCode: '',
        city: '',
        region: '',
        country: '',
        notes: '',
        stopsUntilService: '',
        outageThreshold: '',
      },
      eventsFields: [
        {
          key: 'type',
          sortable: true,
          formatter: this.eventTypeFormatter,
          sortByFormatted: true,
        },
        {
          key: 'time',
          label: 'Time',
          sortable: true,
          formatter: this.eventTimeFormatter,
        },
        {
          key: 'msg',
          label: 'Description',
          sortable: true,
          formatter: (value, key, item) => {
            return this.eventDescriptionForType(item.type, item.msg);
          },
        },
      ],
      eventsFieldsNoTime: [
        {
          key: 'type',
          formatter: this.eventTypeFormatter,
        },
        {
          key: 'msg',
          label: 'Description',
          formatter: (value, key, item) => {
            return value;
          },
        },
        {
          key: 'position',
          formatter: (value, key, item) => {
            return value;
          },
        }
      ],
      outagesFields: [
        {
          key: 'started_at',
          label: 'Time',
          sortable: true,
          formatter: (value, key, item) => {
            return this.outageTimeFormatter(value);
          },
        },
        {
          key: 'duration',
          sortable: true,
          formatter: (value, key, item) => {
            return this.outageDurationFormatter(value);
          },
        },
        {
          key: 'position',
          label: 'Position',
          sortable: true,
        },
        {
          key: 'msg',
          label: 'Description',
          sortable: true,
          formatter: (value, key, item) => {
            return value;
          },
        }
      ],
      errorsFields: [
        {
          key: 'Info',
        },
        {
          key: 'Description',
        },
        /*
        { 
          key: 'Position',
        },
        */
        {
          key: 'LocalTime',
          label: 'Time',
          formatter: (value, key, item) => {
            return this.eventTimeFormatter(value);
          },
        },
      ],
      errorsFieldsNoTime: [
        {
          key: 'Info',
        },
        {
          key: 'Description',
        },
      ],
      admin: auth.admin(),
    }
  },
  computed: {
    outageDuration() {
      if (!this.elevator || !this.elevator.outageAt) return '';
      return moment(this.elevator.outageAt).from(this.now, true);
    },
    canControl() {
      return this.elevator.online == 1 && this.elevator.connected == 1 && this.mode === 'monitor';
    },
    maintenanceDueDateClass() {
      if (!this.elevator || !this.elevator.estimatedDate) return ''
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const d = new Date(this.elevator.estimatedDate)
      const diffDays = Math.floor((d - today) / 86400000)
      if (diffDays <= 0) return ''
      if (diffDays <= 30) return ''
      return ''
    },
    proxyUrl() {
      const base = process.env.NODE_ENV == 'production' ? '' : 'http://x1:1323';
      return `${base}/api/v1/proxy/${this.elevator.id}?token=${localStorage.token}`;
    },
    statsFields() {
      const hasBackDoor = this.elevator.doorBack > 0 ||
        (this.stats && this.stats.some(s => s.openBack > 0 || s.closeBack > 0));
      if (hasBackDoor) {
        return [
          {
            key: 'position',
            label: 'Position',
          },
          {
            key: 'stop',
            label: 'Stops',
          },
          {
            key: 'open',
            label: 'Open',
          },
          {
            key: 'close',
            label: 'Close',
          },
          {
            key: 'openBack',
            label: 'Open Rear',
          },
          {
            key: 'closeBack',
            label: 'Close Rear',
          },
        ]
      } else {
        return [
          {
            key: 'position',
            label: 'Position',
          },
          {
            key: 'stop',
            label: 'Stops',
          },
          {
            key: 'open',
            label: 'Open',
          },
          {
            key: 'close',
            label: 'Close',
          },
        ]
      }
    },
    countStops() {
      var stop = 0;
      for (var i = 0; i < this.stats.length; i++) {
        stop += this.stats[i].stop;
      }
      return stop;
    },
    countOpen() {
      var open = 0;
      for (var i = 0; i < this.stats.length; i++) {
        open += this.stats[i].open;
      }
      return open;
    },
    countOpenBack() {
      var open = 0;
      for (var i = 0; i < this.stats.length; i++) {
        open += this.stats[i].openBack;
      }
      return open;
    },
    countClose() {
      var close = 0;
      for (var i = 0; i < this.stats.length; i++) {
        close += this.stats[i].close;
      }
      return close;
    },
    countCloseBack() {
      var close = 0;
      for (var i = 0; i < this.stats.length; i++) {
        close += this.stats[i].closeBack;
      }
      return close;
    },
    statsChartData: function () {
      if (!this.statsLoaded) {
        return {
          labels: this.oldLabels,
          datasets: this.oldDatasets
        }
      };

      var mylabels = [];
      var stop = [];
      var open = [];
      var close = [];
      var openBack = [];
      var closeBack = [];

      const hasBackDoor = this.elevator.doorBack > 0 ||
        this.stats.some(s => s.openBack > 0 || s.closeBack > 0);

      for (var i = 0; i < this.stats.length; i++) {
        mylabels[i] = this.stats[i].position;
        stop[i] = this.stats[i].stop;
        open[i] = this.stats[i].open;
        close[i] = this.stats[i].close;
        if (hasBackDoor) {
          openBack[i] = this.stats[i].openBack;
          closeBack[i] = this.stats[i].closeBack;
        }
      }

      var mydatasets = [];

      if (hasBackDoor) {
        mydatasets = [
          {
            label: "Stop",
            backgroundColor: "blue",
            data: stop
          },
          {
            label: "Open",
            backgroundColor: "red",
            data: open
          },
          {
            label: "Close",
            backgroundColor: "green",
            data: close
          },
          {
            label: "Open Rear",
            backgroundColor: "darkred",
            data: openBack
          },
          {
            label: "Close Rear",
            backgroundColor: "darkgreen",
            data: closeBack
          }
        ];
      } else {
        mydatasets = [
          {
            label: "Stop",
            backgroundColor: "blue",
            data: stop
          },
          {
            label: "Open",
            backgroundColor: "red",
            data: open
          },
          {
            label: "Close",
            backgroundColor: "green",
            data: close
          }
        ];
      }

      this.oldLabels = mylabels;
      this.oldDatasets = mydatasets;

      return {
        labels: mylabels,
        datasets: mydatasets
      }

    },
  },
  watch: {
    eventsPerPage(v) { localStorage.setItem('elevatorEventsPerPage', String(v)); this.eventsCurrentPage = 1; },
    outagesPerPage(v) { localStorage.setItem('elevatorOutagesPerPage', String(v)); this.outagesCurrentPage = 1; },
  },
  methods: {
    modalResetOpen(button) {
      this.$root.$emit('bv::show::modal', 'modalReset', button);
    },
    modalMPKResetOpen(button) {
      this.$root.$emit('bv::show::modal', 'modalMPKReset', button);
    },
    modalClearErrorsOpen(button, id) {
      this.modalClearErrors.id = id;
      this.$root.$emit('bv::show::modal', 'modalClearErrors', button);
    },
    modalDeleteReset() {
      this.modalClearErrors.id = null;
    },
    clearErrors(data) {
      api.clearErrors(data.id, null);
    },
    clearLog() {
      api.clearLog(this.elevator.id, () => {});
      this.logLines = [];
    },
    onEnter: function () {
      this.updateElevator();
      this.$root.$emit('bv::hide::modal', 'modalForm', this);
    },
    sendMail: function () {
      if (this.body == "") {
        alert("Not sending empty message.");
        return
      }
      api.sendMail({ "subject": this.subject, "body": this.body, "elevator_id": this.elevator.id }, response => {
        if (response.status != 200) {
          alert(response.data["message"]);
          return
        } else {
          alert("Message sent");
          this.subject = "";
          this.body = "";
          return
        }
      });
    },
    updateRelays(relay) {
      if (relay == '1') {
        api.setRelay(this.elevator.id, '1', !this.elevator.relay1, response => {
          if (response.status != 200) {
            alert(response.data[response.status]);
            this.elevator.relay1 = !this.elevator.relay1;
          }
        });
      } else if (relay == '2') {
        api.setRelay(this.elevator.id, '2', !this.elevator.relay2, response => {
          if (response.status != 200) {
            alert(response.data[response.status]);
            this.elevator.relay2 = !this.elevator.relay2;
          }
        });
      }
    },
    updateElevator() {
      this.showAlert = false;
      this.alertMessage = '';
      this.form.stopsUntilService = this.form.stopsUntilService.toString();
      api.updateElevator(this.form, response => {
        if (response.data == "OK") {
          this.getElevator(this.$route.params.id);
          this.form.id = '';
          this.form.name = '';
          this.form.description = '';
          this.form.addressLine1 = '';
          this.form.addressLine2 = '';
          this.form.zipCode = '';
          this.form.city = '';
          this.form.region = '';
          this.form.country = '';
          this.form.notes = '';
          this.form.cid = '';
          this.form.cdate = '';
          this.form.eqdescr = '';
          this.form.stopsUntilService = '';
          this.form.outageThreshold = '';
        } else {
          this.alertMessage = response.data.message;
          this.showAlert = true;
        }
      });
    },
    call(pos) {
      api.putCall(this.elevator.id, pos.toString(), response => {
        if (response.status == 200) {
          alert("Call successful.");
        } else {
          alert("Call failed. ");
        }
      });
    },
    mpkReset() {
      this.ws.send('r');
      api.createActivity('reset_elevator', '', this.elevator.id);
    },
    controllerReset() {
      api.putReset(this.elevator.id, response => {
        if (response.status == 200) {
          alert("Controller reset.");
          this.ws.close();
          this.ws = null;
        } else {
          alert("Controller reset failed.");
        }
      });
    },
    repairOn() {
      api.putRepair(this.elevator.id, "on", response => {
        this.mvLoading = false;
        if (response.status == 200) {
          this.elevator.status = -1;
        }
      });
    },
    repairOff() {
      api.putRepair(this.elevator.id, "off", response => {
        if (response.status == 200) {
          this.elevator.status = 0;
          this.elevator.connected = 0;
        }
      });
    },
    modalInputsOpen(item, index, button) {
      this.inputsLoaded = false;
      api.getElevatorInputs(this.elevator.id, this.inputsGroup, response => {
        this.inputs = [];
        this.inputsLoaded = true;
        switch (response.status) {
          case 200:
            this.inputs = response.data;
            break;
          case 400:
            this.status = "Could not retrieve inputs: Moduview not connected to controller.";
            break;
          case 404:
            this.status = "Could not retrieve inputs: Moduview update required.";
            break;
          default:
            this.status = "Could not retrieve inputs: " + response.status;
            break;
        }
      });
      this.$root.$emit('bv::show::modal', 'modalInputs', button);
    },
    modalStatusReportOpen(item, index, button) {
      this.modalStatusReport.title = 'Status';
      this.statusLoaded = false;
      this.status = "";
      this.statusReport = "";
      api.getElevatorStatus(this.elevator.id, response => {
        this.statusLoaded = true;
        switch (response.status) {
          case 200:
            this.status = "";
            this.statusReport = response.data;
            break;
          case 400:
            this.status = "Could not retrieve status: Moduview not connected to controller.";
            break;
          case 404:
            this.status = "Could not retrieve status: Moduview update required.";
            break;
          default:
            this.status = "Could not retrieve status: " + response.status;
            break;
        }
      });
      this.$root.$emit('bv::show::modal', 'modalStatusReport', button);
    },
    modalErrorsOpen(item, index, button) {
      this.modalErrors.title = 'Events';
      this.errorsLoaded = false;
      this.errors = [];
      api.getElevatorErrors(this.elevator.id, response => {
        this.errorsLoaded = true;
        switch (response.status) {
          case 200:
            this.errors = response.data;
            break;
          case 400:
            this.status = "Could not retrieve events: Moduview not connected to controller.";
            break;
          case 404:
            this.status = "Could not retrieve events: Moduview update required.";
            break;
          default:
            this.status = "Could not retrieve events: " + response.status;
            break;
        }
      });
      this.$root.$emit('bv::show::modal', 'modalErrors', button);
    },
    modalFormOpen(item, index, button) {
      this.modalForm.title = 'Edit Lift';
      this.form.id = this.elevator.id;
      this.form.name = this.elevator.name;
      this.form.description = this.elevator.description;
      this.form.addressLine1 = this.elevator.addressLine1;
      this.form.addressLine2 = this.elevator.addressLine2;
      this.form.zipCode = this.elevator.zipCode;
      this.form.city = this.elevator.city;
      this.form.region = this.elevator.region;
      this.form.country = this.elevator.country;
      this.form.notes = this.elevator.notes;
      this.form.cid = this.elevator.cid;
      this.form.cdate = this.elevator.cdate;
      this.form.eqdescr = this.elevator.eqdescr;
      this.form.stopsUntilService = this.elevator.stopsUntilService.toString();
      this.form.outageThreshold = this.elevator.outage_threshold != null ? String(this.elevator.outage_threshold) : '';
      this.$root.$emit('bv::show::modal', 'modalForm', button);
    },
    modalFormReset() {
    },
    modalPositionLabelsOpen(button) {
      this.positionLabels = this.stats.map(s => ({
        position_int: s.position_int,
        label: s.position,
      }));
      this.$root.$emit('bv::show::modal', 'modalPositionLabels', button);
    },
    savePositionLabels() {
      const id = this.$route.params.id;
      this.positionLabels.forEach(item => {
        api.putPositionLabel(id, item.position_int, item.label, resp => {
          if (resp.status !== 200) {
            console.error('failed to save position label', item);
          }
        });
      });
      setTimeout(() => this.updateStats(), 1000);
    },
    modalInputsClose(item, index, button) {
      this.$root.$emit('bv::hide::modal', 'modalInputs', button);
    },
    modalStatusReportClose(item, index, button) {
      this.$root.$emit('bv::hide::modal', 'modalStatusReport', button);
    },
    modalErrorsClose(item, index, button) {
      this.$root.$emit('bv::hide::modal', 'modalErrors', button);
    },
    modalStatusReportReset() {
    },
    modalErrorsReset() {
    },
    dateFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    reloadCamera() {
      if (this.elevator && this.elevator.camURL && this.elevator.camURL != '') {
        this.camURL = this.getCameraURL();
      }
    },
    getCameraURL() {
      return this.elevator.camURL + '&nocache=' + Math.random();
    },
    setRange(range) {
      switch (range) {
        case 'today':
          this.from = moment.utc().startOf('day').format();
          this.to = moment.utc().endOf('day').format();
          break;
        case 'yesterday':
          this.from = moment.utc().startOf('day').subtract(1, 'day').format();
          this.to = moment.utc().endOf('day').subtract(1, 'day').format();
          break;
        case 'thisWeek':
          this.from = moment().startOf('week').format();
          this.to = moment().endOf('day').format();
          break;
        case 'lastWeek':
          this.from = moment().startOf('week').subtract(1, 'week').format();
          this.to = moment().endOf('week').subtract(1, 'week').format();
          break;
        case 'thisMonth':
          this.from = moment().startOf('month').format();
          this.to = moment().endOf('day').format();
          break;
        case 'lastMonth':
          this.from = moment().startOf('month').subtract(1, 'month').format();
          this.to = moment().subtract(1, 'month').endOf('month').format();
          break;
        case 'thisYear':
          this.from = moment().startOf('year').format();
          this.to = moment().endOf('day').format();
          break;
        case 'lastYear':
          this.from = moment().startOf('year').subtract(1, 'year').format();
          this.to = moment().endOf('year').subtract(1, 'year').format();
          break;
        case 'all':
          if (this.elevator && this.elevator.createdAt) {
            this.from = moment(this.elevator.createdAt).startOf('day').format();
          } else {
            this.from = moment(0).format();
          }
          this.to = moment().endOf('day').format();
          break;
        default:
          break;
      }
      this.fromInput = this.from ? moment(this.from).format('YYYY-MM-DD') : '';
      this.toInput = this.to ? moment(this.to).format('YYYY-MM-DD') : '';
      this.updateAll();
    },
    onEventsSortChanged({ sortBy, sortDesc }) {
      this.eventsSortBy = sortBy;
      this.eventsSortDesc = sortDesc;
      localStorage.setItem('elevatorEventsSortBy', sortBy);
      localStorage.setItem('elevatorEventsSortDesc', sortDesc);
    },
    onOutagesSortChanged({ sortBy, sortDesc }) {
      this.outagesSortBy = sortBy;
      this.outagesSortDesc = sortDesc;
      localStorage.setItem('elevatorOutagesSortBy', sortBy);
      localStorage.setItem('elevatorOutagesSortDesc', sortDesc);
    },
    setFromInput(v) { this.fromInput = v; this.pickDate(); },
    setToInput(v) { this.toInput = v; this.pickDate(); },
    pickDate() {
      this.from = moment(this.fromInput).format();
      this.to = moment(this.toInput).format();
      this.updateAll();
    },
    updateAll() {
      this.updateStats();
      this.updateEvents();
      this.updateOutages();
    },
    updateStats() {
      if (this.from < this.to) {
        this.getElevatorStats(this.$route.params.id, this.from, this.to);
      } else {
        this.stats = [];
      }
    },
    updateEvents() {
      if (this.from < this.to) {
        this.getElevatorEvents(this.$route.params.id, this.from, this.to);
      } else {
        this.events = [];
      }
    },
    updateOutages() {
      if (this.from < this.to) {
        this.getElevatorOutages(this.$route.params.id, this.from, this.to);
      } else {
        this.outages = [];
      }
    },
    updateCurrentOutages() {
      this.getCurrentElevatorOutages(this.$route.params.id);
    },
    refresh() {
      this.getElevator(this.$route.params.id);
    },
    getElevator(id) {
      api.getElevator(id, elevator => {
        if (elevator.data) {
          this.elevator = elevator.data;
          this.loaded = true;
          this.reloadCamera();

          if (this.subject == "") {
            this.subject = this.elevator.host.split(".", 2)[0];
          }

          if (this.elevator.interact && this.mode === 'monitor') {
            this.mode = 'interact';
            if (this.elevator.type === 'lisa') {
              this.logLines = [];
              this.connectLogSocket();
            } else {
              this.connectSocket();
            }
          } else if (!this.elevator.interact && this.mode === 'interact') {
            this.mode = 'monitor';
            this.screen = '';
            this.logLines = [];
            if (this.ws) {
              this.ws.onclose = null;
              this.ws.close();
              this.ws = null;
            }
            if (this.logWs) {
              this.logWs.onclose = null;
              this.logWs.close();
              this.logWs = null;
            }
          }
        } else {
          this.elevator = null;
          this.loaded = false;
        }
      });
    },
    getElevatorStats(id, from, to) {
      this.statsLoaded = false;
      api.getElevatorStats(id, from, to, resp => {
        this.stats = resp.data;
        this.statsLoaded = true;
      });
    },
    getElevatorEvents(id, from, to) {
      const PAGE_SIZE = 1000;
      const excludedTypes = new Set(['stop', 'open', 'close', 'open-back', 'close-back']);
      this.eventsLoaded = false;
      this.eventsCurrentPage = 1;
      const fetchId = ++this._eventsFetchId;

      const drain = (cursor, acc) => {
        api.getElevatorEvents(id, from, to, cursor, PAGE_SIZE, resp => {
          if (fetchId !== this._eventsFetchId) return;
          if (!resp.data) { this.events = acc; this.eventsLoaded = true; return; }
          const page = (resp.data.data || []).filter(e => !excludedTypes.has(e.type));
          const all = acc.concat(page);
          if (resp.data.has_more && resp.data.next_cursor) {
            drain(resp.data.next_cursor, all);
          } else {
            this.events = all;
            this.eventsLoaded = true;
          }
        });
      };
      drain(null, []);
    },
    getElevatorOutages(id, from, to) {
      const PAGE_SIZE = 1000;
      this.outagesLoaded = false;
      this.outagesCurrentPage = 1;
      const fetchId = ++this._outagesFetchId;

      const drain = (cursor, acc) => {
        api.getElevatorOutages(id, from, to, cursor, PAGE_SIZE, resp => {
          if (fetchId !== this._outagesFetchId) return;
          if (!resp.data) { this.outages = acc; this.outagesLoaded = true; return; }
          const page = resp.data.data || [];
          const all = acc.concat(page);
          if (resp.data.has_more && resp.data.next_cursor) {
            drain(resp.data.next_cursor, all);
          } else {
            this.outages = all;
            this.outagesLoaded = true;
          }
        });
      };
      drain(null, []);
    },
    getCurrentElevatorOutages(id, from, to) {
      api.getCurrentElevatorOutages(id, resp => {
        this.currentOutages = resp.data;
      });
    },
    prettyDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm');
    },
    rowClickedHandler(record, index) {
      this.$router.push({ name: 'outage', params: { 'id': record.id } })
    },
    scheduleNowTick() {
      clearTimeout(this.nowTimer);
      const outageAt = this.elevator && this.elevator.outageAt;
      const ms = outageAt && moment().diff(moment(outageAt)) < 60000 ? 1000 : 60000;
      this.nowTimer = setTimeout(() => {
        this.now = moment();
        this.scheduleNowTick();
      }, ms);
    },
    connectLiftWS(id) {
      this.liftWS = openWS('/api/v1/ws/lift/' + id, (msg) => {
        switch (msg.type) {
          case 'elevator_update':
            if (this.elevator) {
              Object.keys(msg.data).forEach(key => {
                if (key === 'stopsIncrement') {
                  this.$set(this.elevator, 'stopsToday', (this.elevator.stopsToday || 0) + msg.data[key]);
                } else if (key === 'dropsIncrement') {
                  this.$set(this.elevator, 'dropsToday', (this.elevator.dropsToday || 0) + msg.data[key]);
                } else {
                  this.$set(this.elevator, key, msg.data[key]);
                }
              });
            }
            break;
          case 'elevator_event':
            if (msg.data && this.eventsLoaded) {
              const excludedTypes = new Set(['stop', 'open', 'close', 'open-back', 'close-back']);
              if (!excludedTypes.has(msg.data.type)) {
                const t = new Date(msg.data.time);
                if (t >= new Date(this.from) && t <= new Date(this.to)) {
                  this.events = [msg.data, ...(this.events || [])];
                }
              }
            }
            if (this.elevator && msg.data) {
              switch (msg.data.type) {
                case 'open': this.$set(this.elevator, 'doorFront', 2); break;
                case 'close': this.$set(this.elevator, 'doorFront', 1); break;
                case 'open-back': this.$set(this.elevator, 'doorBack', 2); break;
                case 'close-back': this.$set(this.elevator, 'doorBack', 1); break;
              }
            }
            if (msg.data && this.stats && this.stats.length > 0) {
              const t = new Date(msg.data.time);
              if (t >= new Date(this.from) && t <= new Date(this.to)) {
                const fieldMap = { stop: 'stop', open: 'open', close: 'close', 'open-back': 'openBack', 'close-back': 'closeBack' };
                const field = fieldMap[msg.data.type];
                if (field) {
                  const idx = this.stats.findIndex(s => s.position_int === msg.data.position);
                  if (idx !== -1) {
                    const row = Object.assign({}, this.stats[idx]);
                    row[field] = (row[field] || 0) + 1;
                    this.$set(this.stats, idx, row);
                  }
                }
              }
            }
            break;
          case 'elevator_outage':
            if (msg.data) {
              const ended = !!msg.data.ended_at;
              if (!ended) {
                const idx = this.currentOutages.findIndex(o => o.id === msg.data.id);
                if (idx === -1) {
                  this.currentOutages = [msg.data, ...this.currentOutages];
                } else {
                  this.$set(this.currentOutages, idx, Object.assign({}, this.currentOutages[idx], msg.data));
                }
              } else {
                this.currentOutages = this.currentOutages.filter(o => o.id !== msg.data.id);
                if (this.outagesLoaded) {
                  const startedAt = new Date(msg.data.started_at);
                  if (startedAt >= new Date(this.from) && startedAt <= new Date(this.to)) {
                    this.outages = [msg.data, ...this.outages];
                  }
                }
              }
            }
            break;
          case 'elevator_io':
            if (msg.data) {
              const { kind, port, value } = msg.data;
              const key = 'io' + kind + port;
              this[key] = value;
              this.hasIO = true;
            }
            break;
        }
      });
    },
    connectSocket() {
      var that = this;

      const wsBase = BASE_URL || (window.location.protocol + '//' + window.location.host);
      const wsProtocol = wsBase.startsWith('https') ? 'wss' : 'ws';

      this.ws = new WebSocket(wsBase.replace(/^https?/, wsProtocol) + '/api/v1/ws/lift/' + this.elevator.id + '/screen?token=' + localStorage.token);

      this.ws.onclose = function (evt) {
        if (that.mode === 'interact') {
          setTimeout(function () { that.connectSocket(); }, 1000);
        }
      };

      this.ws.onmessage = function (evt) {
        evt.data.text().then(function (str) {
          that.screen = str;
        });
      };

      this.ws.onerror = function (err) {
        console.log("Websocket error: " + err);
      };
    },
    connectLogSocket() {
      var that = this;

      const wsBase = BASE_URL || (window.location.protocol + '//' + window.location.host);
      const wsProtocol = wsBase.startsWith('https') ? 'wss' : 'ws';

      this.logWs = new WebSocket(wsBase.replace(/^https?/, wsProtocol) + '/api/v1/ws/lift/' + this.elevator.id + '/log?token=' + localStorage.token);

      this.logWs.onclose = function () {
        if (that.mode === 'interact') {
          setTimeout(function () { that.connectLogSocket(); }, 1000);
        }
      };

      this.logWs.onmessage = function (evt) {
        const str = evt.data;
        try {
          const entry = JSON.parse(str);
          that.logLines.push(entry);
        } catch (e) {
          that.logLines.push({ message: str });
        }
        that.$nextTick(() => {
          const el = that.$refs.lisaLog;
          if (el) el.scrollTop = el.scrollHeight;
        });
      };

      this.logWs.onerror = function (err) {
        console.log("Log websocket error: " + err);
      };
    },
    toggleMode() {
      if (this.mode === 'monitor') {
        this.mode = 'interact';
        if (this.elevator.type === 'lisa') {
          this.logLines = [];
          this.connectLogSocket();
        } else {
          this.connectSocket();
        }
      } else {
        this.mode = 'monitor';
        this.screen = '';
        this.logLines = [];
        if (this.ws) {
          this.ws.onclose = null;
          this.ws.close();
          this.ws = null;
        }
        if (this.logWs) {
          this.logWs.onclose = null;
          this.logWs.close();
          this.logWs = null;
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    history.replaceState(Object.assign({}, history.state, { elevatorFrom: this.from, elevatorTo: this.to }), '');
    next();
  },
  created() {
    this._eventsFetchId = 0;
    this._outagesFetchId = 0;
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
      this.admin = auth.admin();
    }

    if (this.del) {
      api.deleteElevator(this.$route.params.id, resp => {
        alert("deleted " + resp.data);
        this.$router.push({ name: 'elevators' });
      });
    }

    if (this.reset) {
      api.resetElevator(this.$route.params.id, resp => {
        alert("reset " + resp.data);
        this.$router.push('/lifts/' + this.$route.params.id);
      });
    }

    const state = history.state || {};
    if (state.elevatorFrom) {
      this.from = state.elevatorFrom;
      this.to = state.elevatorTo;
    } else {
      this.from = moment.utc().startOf('day').format();
      this.to = moment.utc().endOf('day').format();
    }
    this.fromInput = this.from ? moment(this.from).format('YYYY-MM-DD') : '';
    this.toInput = this.to ? moment(this.to).format('YYYY-MM-DD') : '';
    this.getElevator(this.$route.params.id);
    this.updateAll();
    this.scheduleNowTick();
    this.connectLiftWS(this.$route.params.id);
  },
  beforeDestroy() {
    clearTimeout(this.nowTimer);
    if (this.liftWS) this.liftWS.close();
    if (this.ws) {
      this.ws.onclose = null;
      this.ws.close();
    }
    if (this.logWs) {
      this.logWs.onclose = null;
      this.logWs.close();
    }
  },
}
</script>

<style>
.chart-row {
  min-height: 480px;
}

.table thead th {
  vertical-align: top;
}

pre {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.svg-icon {
  display: inline-flex;
  align-self: center;
}

.svg-icon svg {
  height: 1em;
  width: 1em;
}

.svg-icon.svg-baseline svg {
  top: .125em;
  position: relative;
}

.status-report {
  text-align: center;
}

.status-report pre {
  display: inline-block;
  text-align: left;
  font-family: monospace;
}

.terminal {
  text-align: left;
  font-family: monospace;
  height: 4em;
}

.log-viewer {
  font-family: monospace;
  font-size: 0.85rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px;
  height: 20em;
  overflow-y: auto;
}

.log-line {
  display: flex;
  gap: 8px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-all;
}

.log-time {
  color: #6c757d;
  flex-shrink: 0;
}

.log-level {
  flex-shrink: 0;
  font-weight: bold;
  width: 5em;
}

.log-level--info    { color: #0d6efd; }
.log-level--warn    { color: #fd7e14; }
.log-level--warning { color: #fd7e14; }
.log-level--error   { color: #dc3545; }
.log-level--debug   { color: #adb5bd; }

.log-message {
  flex: 1;
}

.terminal-mpk {
  text-align: left;
  font-family: monospace;
  height: 8em;
}
</style>



// WEBPACK FOOTER //
// src/Elevator.vue